export default __webpack_public_path__ + "static/media/Group18.348a74bf.png";